export default {
    sim_provider_account_delete_title: "Delete SIM Provider Account",
    sim_provider_account_delete_success_message: "The SIM Provider Account has been deleted",
    sim_provider_account_delete_error_message: "It is not possible to delete the SIM Provider Account",
    sim_provider_account_delete_confirm_message: "Are you sure you want to delete the SIM Provider Account?",
    sim_provider_account_in_use: "The sim provider account is linked to some units so it is not possible to delete it",
}